import { addDaysToDateOnly, getTodayDateOnly } from '../../../utils/date-utils';

export const AVAILABLE_SPOTS_PERIOD_PRESETS = [
  { id: 'today', label: 'Hoje', days: 0 },
  { id: '7d', label: '7 dias', days: 7 },
  { id: '15d', label: '15 dias', days: 15 },
  { id: '30d', label: '30 dias', days: 30 },
  { id: '60d', label: '60 dias', days: 60 },
  { id: '90d', label: '90 dias', days: 90 },
  { id: '6m', label: '6 meses', days: 182 },
  { id: '1y', label: '1 ano', days: 365 },
] as const;

export type AvailableSpotsPeriodPresetId =
  (typeof AVAILABLE_SPOTS_PERIOD_PRESETS)[number]['id'];

export type AvailableSpotsPeriodSelection = AvailableSpotsPeriodPresetId | 'custom';

export function computeAvailableSpotsPeriodPresetRange(
  presetId: AvailableSpotsPeriodPresetId,
  anchorDate: string = getTodayDateOnly(),
): { startDate: string; endDate: string } {
  const preset = AVAILABLE_SPOTS_PERIOD_PRESETS.find((item) => item.id === presetId);
  if (!preset) {
    throw new Error(`Preset de período inválido: ${presetId}`);
  }

  return {
    startDate: anchorDate,
    endDate: addDaysToDateOnly(anchorDate, preset.days),
  };
}

export function detectAvailableSpotsPeriodPreset(
  startDate: string,
  endDate: string,
): AvailableSpotsPeriodSelection {
  for (const preset of AVAILABLE_SPOTS_PERIOD_PRESETS) {
    const expected = computeAvailableSpotsPeriodPresetRange(preset.id, startDate);
    if (expected.startDate === startDate && expected.endDate === endDate) {
      return preset.id;
    }
  }
  return 'custom';
}

export function createDefaultAvailableSpotsPeriod(): {
  startDate: string;
  endDate: string;
  periodPresetId: AvailableSpotsPeriodPresetId;
} {
  const startDate = getTodayDateOnly();
  return {
    startDate,
    endDate: addDaysToDateOnly(startDate, 90),
    periodPresetId: '90d',
  };
}
